export default {
    SPIN: '360 View',
    IMAGES: 'Photos',
    VIDEOS: 'Video',
};
